import { useCallback, useRef, useState } from 'react';
import { AlertDialog } from './AlertDialog';
import { ShowAlertDialogContextType } from './context';

export const useAlertDialogValue = () => {
  const ref = useRef<HTMLDialogElement | null>(null);
  const [alertDialogProps, setAlertDialogProps] = useState<Omit<
    React.ComponentProps<typeof AlertDialog>,
    'onClose'
  > | null>(null);

  const showAlertDialog: ShowAlertDialogContextType['showAlertDialog'] = useCallback(arg => {
    setAlertDialogProps(arg);
    if (ref.current) {
      ref.current.showModal();
    }
  }, []);

  const closeAlertDialog = useCallback(() => {
    if (ref.current) {
      ref.current.close();
    }
    setAlertDialogProps(null);
  }, []);

  return { alertDialogProps, ref, showAlertDialog, closeAlertDialog };
};
